import React, { Component } from "react";
import Header from "./components/Header";
import Routes from "./routing/Routes";
import Footer from "./components/Footer";


class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Routes />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js